var _path, _path2, _path3, _rect, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrokenPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.9067H60C60.856 10.9067 61.5498 11.6005 61.5498 12.4565V42.5562L58.2695 40.0962L58 39.894L54 42.894L50 39.894L46 42.894L42 39.894L38 42.894L34 39.894L30 42.894L26 39.894L22 42.894L18 39.894L14 42.894L9.99609 39.8911L9.72461 40.1001L6.4502 42.6265V12.4565C6.4502 11.6005 7.14396 10.9067 8 10.9067Z",
    fill: "#B7ACB7",
    stroke: "#4A304A",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0002 57.093H8.00024C7.1442 57.093 6.45044 56.3993 6.45044 55.5432V46.6848L10.0002 44.0999L13.7356 46.8196L14.0002 47.0129L14.2649 46.8196L18.0002 44.0999L21.7356 46.8196L22.0002 47.0129L22.2649 46.8196L26.0002 44.0999L29.7356 46.8196L30.0002 47.0129L30.2649 46.8196L34.0002 44.0999L37.7356 46.8196L38.0002 47.0129L38.2649 46.8196L42.0002 44.0999L45.7356 46.8196L46.0002 47.0129L46.2649 46.8196L50.0002 44.0999L53.7356 46.8196L54.0002 47.0129L54.2649 46.8196L58.0002 44.0999L61.55 46.6858V55.5432C61.55 56.3993 60.8563 57.093 60.0002 57.093Z",
    fill: "#B7ACB7",
    stroke: "#4A304A",
    strokeWidth: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00024 10.9067H60.0002C60.8563 10.9067 61.55 11.6005 61.55 12.4565V18.0063H6.45044V12.4565C6.45044 11.6005 7.1442 10.9067 8.00024 10.9067Z",
    fill: "#928392",
    stroke: "#4A304A",
    strokeWidth: 0.9
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.7451,
    y: 12.9565,
    width: 26.2567,
    height: 3,
    rx: 1.5,
    fill: "#DBD6DB",
    stroke: "#4A304A",
    strokeWidth: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.998,
    cy: 14.457,
    rx: 1.5,
    ry: 1.5,
    fill: "#DBD6DB",
    stroke: "#4A304A",
    strokeWidth: 0.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5388,
    cy: 14.457,
    rx: 1.5,
    ry: 1.5,
    fill: "#DBD6DB",
    stroke: "#4A304A",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenPage);
export default __webpack_public_path__ + "static/media/brokenPage.cc30f36844ea976cc85563d1db989a22.svg";
export { ForwardRef as ReactComponent };